import React, { useEffect, useState } from "react";
import { Tooltip, Box, Typography, IconButton } from '@mui/material';
import Card from "../../components/card/Card";
import TableContainer from "../../components/table/table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllWarehouse, updateWarehouse } from "../../store/actions/warehouse";
import PermissionComp from "../../components/permissionComp/permissionComp";
import details from '../../assets/details.png'
import ModalButton from "../../components/modalButton/modalButton";
import WareHouseForm from "./warehouseForm";
import edit from '../../assets/edit.png'
import IsDeleteModal from "../../components/isDelete";
import { deleteRecord } from "../../store/reducers/warehouse-slice";

const WareHouse = () => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const navigation = useNavigate()
    const { warehouse } = useSelector(state => state.warehouse)
    const { user } = useSelector(state => state.auth)
    const [warehouses, setWarehouses] = useState([])
    const [open, setOpen] = React.useState(false);

    const tableHeader = ['WareHouse Name', 'Email', 'Website', 'Phone']
    const verifyParam = ['wearHouseName', 'emailAddress', 'website', 'phone']

    useEffect(() => {
        setIsLoading(true)
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLWEARHOUSE",
            "data": { "Company_ID": user?.businessId },
            "debug": null,
            "token": null
        }
        dispatch(getAllWarehouse(data)).then(res => {
            setIsLoading(false)
        })
    }, [])

    useEffect(() => {
        let arr = []
        warehouse.forEach((ele) => {
            const obj = { ...ele }
            // obj['isActive'] = obj.isActive ? "Active" : obj.isActive ? "Non-Active" : '';
            arr.push(obj)
        })
        setWarehouses(arr)

    }, [warehouse])

    const deleteUser = (data) => {
        let obj = {
            "WearHouseName": null,
            "EmailAddress": null,
            "Website": null,
            "Phone": null,
            "CompanyID": null,
            "CreatedBy": null,
            "ID": data.id,
            "EditBy": user?.userId,
            "ISUPDATE": 0,
        }
        let sentObj = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "UPDATEWEARHOUSE",
            "data": obj,
            "debug": null,
            "token": null
        }
        dispatch(updateWarehouse(sentObj)).then(res => {
            setIsLoading(false)
            dispatch(deleteRecord(obj))
            setOpen(false)
        })
    }
    return (
        <>
            <Box sx={{ margin: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h1' >Warehouse</Typography>
                <PermissionComp list={['Wearhouse', 'create']}>
                    <ModalButton open={open} setOpen={setOpen} tooltip={'Create Wearhouse'} type={'Button'}>
                        <WareHouseForm setOpen={setOpen} />
                    </ModalButton>
                </PermissionComp>
            </Box>
            <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <TableContainer tableHeader={tableHeader}
                    data={warehouses}
                    verifyParam={verifyParam}
                    isLoading={isLoading}
                    action={(data) => <TableAction id={data.id} deleteRecord={deleteUser} />} />
            </Card>
        </>
    );
};

export default WareHouse;




const TableAction = ({ id, deleteRecord }) => {
    const navigation = useNavigate()
    const [openEdit, setOpenEdit] = React.useState(false);

    return (
        <Box>
            <Tooltip title="Wearhouse Products">
                <IconButton onClick={() => navigation('wearhouseProducts', { state: id })} sx={{ width: '40px', margin: '0px auto' }}>
                    <img src={details} style={{ width: '25px', height: '25px', objectFit: 'contain' }} />
                </IconButton>
            </Tooltip>
            <PermissionComp list={['Wearhouse', 'edit']}>
                <ModalButton open={openEdit} setOpen={setOpenEdit} tooltip={'Edit Wearhouse'} img={edit} type={'icon'}>
                    <WareHouseForm data={id} setOpen={setOpenEdit} />
                </ModalButton>
            </PermissionComp>
            <PermissionComp list={['Wearhouse', 'delete']}>
                <IsDeleteModal onPress={() => deleteRecord(id)} />
            </PermissionComp>
        </Box>
    )
}